/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Timer/theme';

export const TimerTheme = theme;
